module.exports = __webpack_public_path__ + "static/img/photo-of-imac-near-macbook-1029757.5d3cda8b.jpg";